import IReader from './IReader'
import LayerBean from '../beans/LayerBean'

export default class LayerReader extends IReader {
    constructor() {
        super(LayerBean)
    }

    /**
     * 读取shp文件
     * @param {LayerBean} layerBean
     */
    async _read(layerBean) {
        const features = []
        const { map, layers } = layerBean

        const layer = map.getLayer(layers[0])
        const source = map.getSource(layer.source)

        // geojson图层
        if (source && source._data) {
            features.push(JSON.parse(JSON.stringify(source._data.features)))
        }
        // 矢量切片图层（只查询渲染部分）
        else {
            const fs = map.queryRenderedFeatures({ layers }).map(f => {
                const { id, type, geometry, properties } = f.toJSON()
                return {
                    id,
                    type,
                    geometry: JSON.parse(JSON.stringify(geometry)),
                    properties: { ...properties }
                }
            })
            features.push(...fs)
        }
        return features
    }
}
